import { render, staticRenderFns } from "./ModalEditEventDescription.vue?vue&type=template&id=e5355182"
import script from "./ModalEditEventDescription.vue?vue&type=script&lang=js"
export * from "./ModalEditEventDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports